export const Chat = `
<path d='M842.831 0H102.4C46.08 0 0 46.08 0 102.4V1024L204.8 819.2H842.831C899.151 819.2 945.231 773.12 945.231 716.8V102.4C945.231 46.08 899.151 0 842.831 0Z'/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/chat.js